import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ConsentIntegrationOptions} from "../components/consentIntegrationSection/ConsentIntegrationSection";

export const sendTestOtpMessage = async (domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `communication-provider/send-preview-code`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
        isEncrypted: true,
    });
}